import React from "react"
import { Button } from "./button"
import { useAuth0 } from "@auth0/auth0-react"
import { useTranslation } from "../../i18n"

export default function AuthButton() {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0()
  const { t } = useTranslation()

  if (!isAuthenticated) {
    return (
      <Button
        variant="outline"
        onClick={() => loginWithRedirect()}
      >
        {t("profileMenu.logIn")}
      </Button>
    )
  }

  return (
    <Button
      variant="outline"
      onClick={() =>
        logout({ logoutParams: { returnTo: window.location.origin } })
      }
    >
      {t("profileMenu.logOut")}
    </Button>
  )
}
